module.exports = __webpack_public_path__ + "media/chapter_3.5c3bac47.webm";